export default {
	install(Vue, options) {
		Vue.prototype.baseUrl = function() {
			return '111';
		};
		Vue.prototype.site = {
			title: '测试',
			url: '192.168.31.104:20005'
		};
		Vue.prototype.showFootTab = {
			isShow: false,
			active: 0,
		}
	}
}